module.exports = __webpack_public_path__ + "img/map-14.57fab60e.png";